export default __webpack_public_path__ + "static/media/checkbox-enabled-checked.3475c2c7.svg";